import { Carousel } from 'antd';
import TagCarouselLoading from '../../../skeleton/TagCarouselLoading';
import SectionHeader from '../../SectionHeader/SectionHeader';
import TagCard from './TagCard';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  variableWidth: true,
  draggable: true,
  loop: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
};
function TagCarousel({
  className,
  icon,
  headerLink,
  data = [],
  sectionHeading,
  headerDescription
}) {
  return (
    <div className="tag-carousel">
      <SectionHeader
        headerLink={headerLink}
        heading={sectionHeading}
        headerDescription={headerDescription}
      />
      <Carousel {...settings}>
        {data?.map((item) => {
          return (
            <div key={item?.id}>
              <TagCard
                className={className}
                icon={icon}
                name={item?.name}
                href={item?.href}
              />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

TagCarousel.Loading = function Loading() {
  return <TagCarouselLoading settings={settings} />;
};

export default TagCarousel;
